import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from "src/app/constants";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BookingInfoService } from 'src/app/service/export-parts/booking-info.service';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss']
})
export class WarningDialogComponent implements OnInit {
  playAudio: Subject<any> = new Subject();
  heading: any;
  eventType: any;
  waybill: any;
  successMessage: any
  errorMessage: any;
  menuOption: any;
  constructor(public dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private constants: Constants, private ngxUiLoaderService: NgxUiLoaderService, 
  private service: BookingInfoService,) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    console.log("inside warning tab",this.dataStore.data)
    if(this.eventType == 'delete'){
      if(this.dataStore.data.length > 0){
        this.waybill = this.dataStore.data[0].waybill
      }
    }
    if(this.eventType == 'deleteLoadType'){
      if(this.dataStore.data.length > 0){
        this.menuOption = this.dataStore.data[0]?.menu_options
      }
    }
  }
  clearMsg() {
    this.successMessage = "";
    this.errorMessage = "";
  }
  showError(msg: string) {
    this.playAudio.next('trouble');
    this.errorMessage = msg;
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public confirm(){
    if(this.eventType == 'delete'){
      this.ngxUiLoaderService.start()
      this.service.deleteBookingInfo(this.waybill).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              this.dialogRef.close({
                event: "success",
                // data : this.description
              });
              this.clearMsg();
              this.successMessage = this.constants.APIDataDeleted
              this.showError(this.successMessage);
            }
            if(res.status == 'FAILURE'){
              this.dialogRef.close({
                event: "failure",
                // data : this.description
              });
              this.clearMsg();
              this.errorMessage = this.constants.APIErrorMessage
              this.showError(this.errorMessage);
            }
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
          this.dialogRef.close({
            event: "APIError",
            // data : this.description
          });
        }
      })
    }
    if(this.eventType == 'deleteLoadType'){
      let data = {
        "menu":this.dataStore?.data[0]?.menu_options,
        "dock":this.dataStore.data[0]?.dock_code,
        "load":this.dataStore.data[0]?.load_types,
        "ship":this.dataStore.data[0]?.ship_file_code,
        }
      this.ngxUiLoaderService.start()
      this.service.deleteLoad(data).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              this.dialogRef.close({
                event: "success",
                // data : this.description
              });
              this.clearMsg();
              this.successMessage = this.constants.APIDataDeleted
              this.showError(this.successMessage);
            }
            if(res.status == 'FAILURE'){
              this.dialogRef.close({
                event: "failure",
                // data : this.description
              });
              this.clearMsg();
              this.errorMessage = this.constants.APIErrorMessage
              this.showError(this.errorMessage);
            }
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
          this.dialogRef.close({
            event: "APIError",
            // data : this.description
          });
        }
      })
    }
    if(this.eventType == 'deleteContainer'){
      let data = {
        "container":this.dataStore.data[0]?.container,
        "renban":this.dataStore.data[0]?.renban,
        "waybill":this.dataStore.data[0]?.waybill,
        }
      this.ngxUiLoaderService.start()
      this.service.deleteContainer(data).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              this.dialogRef.close({
                event: "success",
                // data : this.description
              });
              this.clearMsg();
              this.successMessage = this.constants.APIDataDeleted
              this.showError(this.successMessage);
            }
            if(res.status == 'FAILURE'){
              this.dialogRef.close({
                event: "failure",
                // data : this.description
              });
              this.clearMsg();
              this.errorMessage = this.constants.APIErrorMessage
              this.showError(this.errorMessage);
            }
           
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
          this.dialogRef.close({
            event: "APIError",
            // data : this.description
          });
        }
      })
    }
    
    
    if(this.eventType == 'reopenContainer'){
      let data = {
        "container":this.dataStore.data[0]?.container,
        "renban":this.dataStore.data[0]?.renban,
        "waybill":this.dataStore.data[0]?.waybill,
        }
      this.ngxUiLoaderService.start()
      this.service.reopenContainer(data).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              this.dialogRef.close({
                event: "success",
                // data : this.description
              });
              this.clearMsg();
              this.successMessage = this.constants.APIDataReopened
              this.showError(this.successMessage);
            }
            if(res.status == 'FAILURE'){
              this.dialogRef.close({
                event: "failure",
                // data : this.description
              });
              this.clearMsg();
              this.errorMessage = this.constants.APIErrorMessage
              this.showError(this.errorMessage);
            }
           
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
          this.dialogRef.close({
            event: "APIError",
            // data : this.description
          });
        }
      })
    }
  
  }

}
